import { FC, ReactNode } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';

interface HeaderProps {
  children: ReactNode;
  showLogo?: boolean;
  headerStyles?: Interpolation<Theme>;
  color?: string;
}

export const Header: FC<HeaderProps> = ({ children, showLogo, headerStyles, color = theme.colors.white }) => {
  return (
    <div css={[styles.container, headerStyles]}>
      {showLogo && <Icon name='weave-logo-small' size={24} css={{ color }} />}
      {typeof children === 'string' ? (
        <Heading level={3} css={{ color }}>
          {children}
        </Heading>
      ) : (
        children
      )}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
  `,
};
